import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Message, MessageContent } from '@/features/chat/chatSlice';

interface ChatMessageProps {
  message: Message;
}

const getDisplayContent = (content: MessageContent): string => {
  if (typeof content === 'string') {
    return content;
  }
  return content.userFacingMessage;
};

export const ChatMessage = ({ message }: ChatMessageProps) => {
  const { author, content } = message;
  const displayContent = getDisplayContent(content);

  return (
    <div className={`flex items-start gap-4 p-4 ${author === 'user' ? 'justify-end' : ''}`}>
      {author === 'ai' && (
        <Avatar className="h-8 w-8">
          <AvatarImage src="/ai-avatar.png" alt="AI" />
          <AvatarFallback>AI</AvatarFallback>
        </Avatar>
      )}
      <div
        className={`rounded-lg p-3 max-w-[75%] ${author === 'user' ? 'bg-primary text-primary-foreground' : 'bg-muted'}`}>
        <p className="text-sm">{displayContent}</p>
      </div>
      {author === 'user' && (
        <Avatar className="h-8 w-8">
          <AvatarImage src="/user-avatar.png" alt="User" />
          <AvatarFallback>You</AvatarFallback>
        </Avatar>
      )}
    </div>
  );
};
